module.exports = __webpack_public_path__ + "static/media/segoeuib.4056244b.ttf";